import React, { Component } from 'react'

class EditAlertContentField extends Component {
    constructor(props) {
        super()
        this.state = {
            localContent: props.infoItem.includes("nullStepItem") ? "" : props.infoItem,
            fieldId: `item-renaming-container-${props.infoItem}`,
            error: false,
            hasBeenEdited: false
        }
        this.textAreaRef = React.createRef();
    }

    componentDidMount() {
        if (this.textAreaRef.current) {
            this.textAreaRef.current.focus();
            this.textAreaRef.current.addEventListener("keydown", this.checkKey);
        }
        // Mark as initialized after mount
        this.setState({ isInitialized: true });
    }

    // Only update state from props on initial mount
    static getDerivedStateFromProps(props, state) {
        if (!state.isInitialized) {
            return {
                name: props.infoItem.includes("nullStepItem") ? "" : props.infoItem
            };
        }
        return null;  // Never update state from props after initialization
    }

    componentWillUnmount() {
        if (this.textAreaRef.current) {
            this.textAreaRef.current.removeEventListener("keydown", this.checkKey);
        }
    }

    checkKey = (e) => {
        if (e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            this.handleSubmit(e);
        }
    }

    handleChange = (e) => {
        this.setState({ 
            localContent: e.target.value,
            error: false,
            hasBeenEdited: true
        });
    }

    handleBlur = (e) => {
        const content = this.state.localContent.trim();
        
        if (content && this.state.hasBeenEdited) {
            this.handleSubmit(e);
        } else if (!content && !this.props.infoItem.includes("nullStepItem")) {
            // Revert to original content if empty and not a new alert
            this.setState({ 
                localContent: this.props.infoItem,
                hasBeenEdited: false 
            });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        
        const content = this.state.localContent.trim();
        
        if (!content) {
            this.setState({ error: true });
            return;
        }

        if (this.props.infoItem !== content) {
            this.props.editItemName(this.props.infoItem, content);
            this.setState({ hasBeenEdited: false });
        }
    }

    render() {
        // const errorStyle = {
        //     color: '#dc3545',
        //     fontSize: '0.8rem',
        //     marginTop: '4px',
        //     fontWeight: '500'
        // };

        // const textAreaStyle = {
        //     width: "98%",
        //     height: "70px",
        //     border: this.state.error ? '1px solid #dc3545' : '1px solid #ced4da',
        //     borderRadius: '4px',
        //     padding: '8px',
        //     resize: 'vertical'
        // };

        return (
            <span 
                id={`info-item-edit-field-${this.state.fieldId}`} 
                style={{height: '100%'}} 
                className="overflow max-width flex-column"
            >
                <textarea
                    ref={this.textAreaRef}
                    id={this.state.fieldId}
                    type="text"
                    placeholder="Name Your Info Item"
                    value={this.state.localContent}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    style={{
                        width: "98%",
                        height: "70px",
                        border: this.state.error ? '1px solid #dc3545' : '1px solid #ced4da',
                        borderRadius: '4px',
                        padding: '8px'
                    }}
                />
                {this.state.error && (
                    <div style={{ color: '#dc3545', fontSize: '0.8rem', marginTop: '4px' }}>
                        Info Items Cannot Be Blank
                    </div>
                )}
            </span> 
        )
    }
}

export default EditAlertContentField